import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {action, computed, observable, reaction} from 'mobx';
import {Link} from 'react-router';
import autobind from 'autobind-decorator';

import {withContent, withI18n} from 'spa/Components/Context';

import './ReferralBanner.less';

@inject(({store: {session, tracker}}) =>
  (
    {
      session,
      tracker,
    }
  ))
@observer
@withContent
@withI18n
class ReferralBanner extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    session: PropTypes.object.isRequired,
    trackingCategory: PropTypes.string,
  };

  UNSAFE_componentWillMount() {
    const {content, i18n} = this.context;

    this.contentTitle = content.getLocaleValue('banner_text', i18n.contentRegion, 'string');
    this.contentUrl = content.getLocaleValue('banner_url', i18n.contentRegion, 'string');
  }

  componentDidMount() {
    const {session} = this.props;
    const {content, i18n} = this.context;

    this.listeners = [
      reaction(
        () => session.user,
        (user) => {
          // If user has no bookings or has no meta property because they've just come from the signup page
          if (user && (!user.meta || (user.meta && user.meta.stats && (user.meta.stats.totalBookings === 0 && user.meta.stats.upcomingBookings === 0)))) {
            this.contentTitle = content.getLocaleValue('banner_text_logged_false', i18n.contentRegion, 'string');
            this.contentUrl = content.getLocaleValue('banner_url_logged_false', i18n.contentRegion, 'string');
          } else if (user && user.meta && user.meta.stats && (user.meta.stats.totalBookings > 0 || user.meta.stats.upcomingBookings > 0)) {
            // Otherwise the user has bookings so lets show this contextual text
            this.contentTitle = content.getLocaleValue('banner_text_logged_true', i18n.contentRegion, 'string');
            this.contentUrl = content.getLocaleValue('banner_url_logged_true', i18n.contentRegion, 'string');
          }
        },
        {
          name: 'Show user specific banner content',
          fireImmediately: true,
        },
      ),
    ];
  }

  componentWillUnmount() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }

  @observable contentTitle;
  @observable contentUrl;

  @autobind
  @action('Clicked referral banner link')
  onClickLink(event) {
    this.props.tracker.track('Clicked homepage banner', {
      category: this.props.trackingCategory,
      label: 'Homepage banner',
    });
  }

  @autobind
  @action('Clicked referral banner with no link')
  onClickBanner(event) {
    this.props.tracker.track('Clicked homepage banner with no URL', {
      category: this.props.trackingCategory,
      label: 'Homepage banner',
    });
  }

  @computed get isExternalUrl() {
    if (!this.contentUrl) return false;
    return /^(http|https):/.test(this.contentUrl);
  }

  render() {
    const {active} = this.props;
    const {
      contentTitle, contentUrl, context, isExternalUrl, onClickBanner, onClickLink,
    } = this;
    const {i18n} = context;

    if (!active) {
      return null;
    }

    if (this.contentTitle) {
      if (!this.contentUrl) {
        return (
          <div className="referral-banner">
            <div
              className="referral-banner__text"
              onClick={onClickBanner}
              dangerouslySetInnerHTML={{ __html: contentTitle}}
            />
          </div>
        );
      }
      if (isExternalUrl) {
        return (
          <div className="referral-banner">
            <a
              dangerouslySetInnerHTML={{ __html: contentTitle}}
              className="referral-banner__link"
              data-qa="referral-banner"
              href={contentUrl}
              onClick={onClickLink}
              target="_blank" // eslint-disable-line react/jsx-no-target-blank
              rel="noopener"
            />
          </div>
        );
      }
      return (
        <div className="referral-banner">
          <Link
            className="referral-banner__link"
            data-qa="referral-banner"
            onClick={onClickLink}
            to={`/${i18n.lc}/${contentUrl}`}
            dangerouslySetInnerHTML={{ __html: contentTitle}}
          />
        </div>
      );
    }

    return null;
  }
}

export default ReferralBanner;



// WEBPACK FOOTER //
// ./spa/Components/ReferralBanner.jsx